import { Client } from '@/manager/client/client.model';
import Provider from '@/manager/business/models/provider.model';
import BillLine from '@/manager/billing/models/bill-line.model';
import { PaymentMethod } from '@/clickbuy/purchase/models/purchase.model';
import { User } from '@/shared/models/user.model';

export default class FiscalDataExtension {
    public id?: string;
    public user?: User;
    public firstName?: string;
    public lastName?: string;
    public secondLastName?: string;
    public email?: string;
    public nif?: string;
    public phone?: string;
    public purchaseOrigin?: string;
    public date?: string;
    public address?: string;
    public postalCode?: string;
    public town?: string;
    public state?: string;
    public country?: string;
    public isDefault?: boolean;
    
    constructor(){
        this.isDefault=false;
        this.user = new User();
        this.firstName='SIN DATOS'
        this.lastName='SIN DATOS'
        this.email='SIN@DATOS.COM'
        this.nif='SIN DATOS'
        this.phone='+34'
        this.date='SIN DATOS'
        this.address='SIN DATOS'
        this.postalCode='SIN DATOS'
        this.town='SIN DATOS'
        this.state='SIN DATOS'
        this.country='SIN DATOS'
    }

    // constructor() {
    //     this.client = new Client();
    //     this.provider = new Provider();
    //     const newLine = new BillLine();
    //     this.billLine = [newLine];
    //     this.transactionType = TransactionType.TransactionEmitted;
    //     this.paymentMethod = PaymentMethod.Cash;
    // }
}
